import { Button } from "@sellar-io/components";
import { SupplierRelationshipListNewResponseType } from "@sellar-io/api-v2/types";
import { ConnectionPaymentTermsRequestIndicatorChange } from "../../../../components/connectionPaymentTermsRequest/ConnectionPaymentTermsRequestIndicatorChange";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { useSupplierRelationshipPaymentTermsRequestUpdate } from "../../../../hooks/api/v2/supplierRelationshipPaymentTermsRequest/useSupplierRelationshipPaymentTermsRequestUpdate";

export const CustomerListCreditTermsRequestDialog = ({
  connection,
  active,
  onDismiss,
}: {
  connection: SupplierRelationshipListNewResponseType[number];
  active: boolean;
  onDismiss: () => void;
}) => {
  if (
    connection.SupplierRetailerConnectionPaymentTermsRequest?.status !==
    "pending"
  )
    return null;

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <CustomerListCreditTermsRequestDialogContent
        connection={connection}
        onDismiss={onDismiss}
        paymentTermsRequestId={
          connection.SupplierRetailerConnectionPaymentTermsRequest.id
        }
      />
    </Dialog>
  );
};

const CustomerListCreditTermsRequestDialogContent = ({
  connection,

  onDismiss,
  paymentTermsRequestId,
}: {
  connection: SupplierRelationshipListNewResponseType[number];
  paymentTermsRequestId: number;
  onDismiss: () => void;
}) => {
  const connectionPaymentTermsRequestUpdateMutation =
    useSupplierRelationshipPaymentTermsRequestUpdate(paymentTermsRequestId);
  const onSubmit = (status: "rejected" | "accepted") => {
    return connectionPaymentTermsRequestUpdateMutation.mutate(
      {
        status,
      },
      {
        onSuccess: () => onDismiss(),
      },
    );
  };
  const isLoading = connectionPaymentTermsRequestUpdateMutation.isPending;
  return (
    <>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Credit terms requested"}
      />
      <DialogContent className={"flex flex-col gap-4"}>
        <p>
          <strong>{connection.Retailer.Business.name}</strong> has requested to
          have credit terms assigned to their account. You can assign their
          chosen credit terms which are stated below, or deny their request to
          keep their original terms
        </p>
        <ConnectionPaymentTermsRequestIndicatorChange
          connection={{
            ...connection,
            PaymentTermsRequest:
              connection.SupplierRetailerConnectionPaymentTermsRequest,
          }}
        />
      </DialogContent>
      <DialogCTA>
        <Button
          disabled={isLoading}
          onClick={() => onSubmit("rejected")}
          color={"red"}
        >
          Deny request
        </Button>
        <Button
          disabled={isLoading}
          onClick={() => {
            onSubmit("accepted");
          }}
        >
          Assign terms
        </Button>
      </DialogCTA>
    </>
  );
};
